import { compose } from 'redux';
import { connect } from 'react-redux';
import IframePage from './IframePage';

const mapStateToProps = state => ({
    territory: state.subscriptions.territory,
    sites: state.marketingSites,
});

const enhance = compose(connect(mapStateToProps));

export default enhance(IframePage);
